export default {"src":"/_next/static/media/ni.52dea661.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};